import RestrictedUserRoute from "discourse/routes/restricted-user";

export default class PreferencesEmails extends RestrictedUserRoute {}
